module.exports = "<div class=\"main-wrapper\">\r\n  <app-header></app-header>\r\n\r\n  <router-outlet></router-outlet>\r\n\r\n  <app-footer></app-footer>\r\n</div>\r\n<toaster-container></toaster-container>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main